<template>
  <v-form ref="form" @submit.prevent="saveForm">
    <BaseFileUpload
      accept=".pdf"
      :files.sync="files"
      text="Dodaj dokumenty, które mają zostać uzupełnione po wykonanym serwisie."
      helperText="Możesz dodać max. 50 plików PDF."
      @downloadFile="$emit('downloadFile', $event)"
    />
    <DialogSaveButton type="submit" style="padding-left: 0 !important; padding-right: 0 !important" />
  </v-form>
</template>

<script>
import BaseFileUpload from '@/component/Base/file-upload/base-file-upload';
import DialogSaveButton from '@/component/Dialog/dialog-save-button';
import { mapGetters } from 'vuex';
import { SERVICE_TYPE_DICT } from '@/core/dict/service-type-dict';

export default {
  name: 'CargoCorrection',
  components: {
    BaseFileUpload,
    DialogSaveButton,
  },
  props: {
    entity: Object,
    isAddMode: Boolean,
  },
  data() {
    return {
      files: [],
    };
  },
  created() {
    if (!this.isAddMode && this.entity) {
      this.files = this.entity.attachments.map((file) => ({ ...file, name: file.mediaObject.filePath }));
    } else if (this.isCargoCorrectionAdded) {
      const service = this.$store.getters['service/services'].find(
        ({ serviceType }) => serviceType === SERVICE_TYPE_DICT.CARGO_CORRECTION
      );
      this.files = service.attachments;
    }
  },
  computed: {
    ...mapGetters('service', ['isCargoCorrectionAdded']),
  },
  methods: {
    saveForm() {
      if (this.$refs.form.validate()) {
        const payload = {
          serviceType: SERVICE_TYPE_DICT.CARGO_CORRECTION,
          attachments: this.files,
        };

        if (this.isAddMode) {
          this.$emit('addServiceItem', payload);
        } else if (this.entity) {
          this.$emit('editExistingServiceItem', payload);
        } else if (this.isCargoCorrectionAdded) {
          this.$store.dispatch('service/updateService', payload);
        } else {
          this.$store.dispatch('service/addService', payload);
        }

        this.$emit('submit');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
